var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import { Plan } from '../type/pickups';
export var configInstance = (process.env.INSTANCE ||
    process.env.NEXT_PUBLIC_INSTANCE ||
    process.env.REACT_APP_INSTANCE);
try {
    if (!configInstance) {
        if (typeof location !== 'undefined') {
            if (window.location.host.split('.')[0] === 'dev' ||
                window.location.host.split('.')[1] === 'dev' ||
                window.location.host.split('.')[2] === 'dev' ||
                window.location.hostname.includes('localhost')) {
                configInstance = 'dev';
            }
            else if (window.location.host.split('.')[0] === 'stage' ||
                window.location.host.split('.')[1] === 'stage') {
                configInstance = 'stage';
            }
            else {
                configInstance = 'prod';
            }
        }
        else {
            configInstance = 'prod';
        }
    }
}
catch (err) {
    console.error('Config get instance by location error', err);
}
var defaultConfigs = {
    dev: {
        aws: {
            region: 'us-west-2',
            graphqlEndpoint: 'https://iosyrbeanbesngs573v7pxc2aq.appsync-api.us-west-2.amazonaws.com/graphql',
            authenticationType: 'AMAZON_COGNITO_USER_POOLS',
            apiKey: 'da2-3kjqjd2k5jbmddmzrnp2csnjwq',
            graphqlPartnerEndpoint: 'https://rnzwhvmmwjgbxenvd62jeyzrmq.appsync-api.us-west-2.amazonaws.com/graphql',
            partnerApiKey: 'da2-indtvgh5tjcnhp4rjox4svmhua',
            graphqlNotificationsEndpoint: 'https://3h3qtszp7jf4zhd6o363eyn66e.appsync-api.us-west-2.amazonaws.com/graphql',
            notificationsApiKey: 'da2-sumxv3j26jhjvg5pddqo3sfjfy',
            identityPoolId: 'us-west-2:da272047-c713-44e1-abdc-f90ccab5d684',
            userPoolId: 'us-west-2_6lNZdv9GP',
            userPoolWebClientId: '33g0j6m90iqjd64u7gmhptdv2t',
            labelBucket: 'returnmates-label-dev',
            mediaBucket: 'returnmates-media-dev',
            apiGatewayGoldengateEndpoint: 'https://vxky4iu18d.execute-api.us-west-2.amazonaws.com/dev',
            apiGatewayGoldengateApiKey: 'TYCpPa5XPtla3flOCfgKoeMPPG5xQAx25I3tUVk8Y8Xphu64rtfDjYHJtYCwDb8YOq9tk47MeKVNXHuDE0m3p1w9cbzeqVKHf6KLwmtkraoq5xaMKEY0wipnwM4vy4Tj',
        },
        google: {
            maps: 'AIzaSyCaCaPIsvcNNkIxtVKYql_PUF2bmavRVcQ',
        },
        stripe: {
            publicKey: 'pk_test_51H0rulEfxrgq4pDvCYMIMlV3BSE00rOckRdepuz7Mr5Bty2Ij9rDHq3ctJY08dgJH69ktkxH6vqm0FN8mm3XBKGS004SZ4diLj',
        },
        paymentCodes: (_a = {},
            _a[Plan.PER_PICKUP] = 'prod_JEMEkA76Ju085p',
            _a[Plan.MEMBERSHIP] = 'prod_JEMBMOz7fy4FoO',
            _a),
        subscriptionPriceId: 'price_1IbtSiEfxrgq4pDvBITP26CG',
        oauth: {
            iosClientId: '106428630706-a8unm2f9vv2v6g1kmhfnkrjb3svcqd9p.apps.googleusercontent.com',
            androidClientId: '106428630706-jc4p1j48oclg7r8h2t87cp5fqjhna445.apps.googleusercontent.com',
        },
        returnmates: {
            shopify: 'https://dev-api.returnmates.com/shopify',
            client: 'https://dev.returnmates.com',
        },
    },
    stage: {
        aws: {
            region: 'us-west-2',
            graphqlEndpoint: 'https://hv47cafp3zb2nnvihb2iqjr3g4.appsync-api.us-west-2.amazonaws.com/graphql',
            authenticationType: 'AMAZON_COGNITO_USER_POOLS',
            apiKey: 'da2-w3liqei7ovgrfgjjxxk5izv6fy',
            graphqlPartnerEndpoint: 'https://dpo2q6v5dbggvked63zleiv7fa.appsync-api.us-west-2.amazonaws.com/graphql',
            partnerApiKey: 'da2-knnjndvpbfhddoc22ngapmkxtq',
            graphqlNotificationsEndpoint: 'https://fi35izoywbhstopbytkiqyyvee.appsync-api.us-west-2.amazonaws.com/graphql',
            notificationsApiKey: 'da2-xbeovxvmbfhdxiaxst4mugcvy4',
            identityPoolId: 'us-west-2:48a85546-ffff-4341-a23e-7e6d93ef2c7a',
            userPoolId: 'us-west-2_Ufr9cnSJR',
            userPoolWebClientId: '668li56c7qeeaandvd7egs1k7g',
            labelBucket: 'returnmates-label-dev',
            mediaBucket: 'returnmates-media-stage',
            apiGatewayGoldengateEndpoint: 'https://br5igoysw5.execute-api.us-west-2.amazonaws.com/stage',
            apiGatewayGoldengateApiKey: 'wou83M8BqLf9jCC7oqJT4eHAN0rlqOzBZl4LUlEfNR28BkBNNl8gUCRCAjsiiYIZqKldLaUdAWEwkp9Po7TrpNTvK5J7zmnZ4gWUOI2SIiCXZzG3P6QaQwojNhmMLcJ6',
        },
        google: {
            maps: 'AIzaSyCaCaPIsvcNNkIxtVKYql_PUF2bmavRVcQ',
        },
        stripe: {
            publicKey: 'pk_test_51H0rulEfxrgq4pDvCYMIMlV3BSE00rOckRdepuz7Mr5Bty2Ij9rDHq3ctJY08dgJH69ktkxH6vqm0FN8mm3XBKGS004SZ4diLj',
        },
        paymentCodes: (_b = {},
            _b[Plan.PER_PICKUP] = 'prod_N1Fx0MbJxja5EY',
            _b[Plan.MEMBERSHIP] = 'prod_N1Fz4kU2q97Ogw',
            _b),
        subscriptionPriceId: 'price_1MHDTaEfxrgq4pDv23hYMdtm',
        oauth: {
            iosClientId: '106428630706-a8unm2f9vv2v6g1kmhfnkrjb3svcqd9p.apps.googleusercontent.com',
            androidClientId: '106428630706-jc4p1j48oclg7r8h2t87cp5fqjhna445.apps.googleusercontent.com', //TODO check stage env
        },
        returnmates: {
            shopify: 'https://stage-api.returnmates.com/shopify',
            client: 'https://stage.returnmates.com',
        },
    },
    prod: {
        aws: {
            region: 'us-west-2',
            graphqlEndpoint: 'https://gbj3ytxt5bcrxp7ctru6m4ktna.appsync-api.us-west-2.amazonaws.com/graphql',
            authenticationType: 'AMAZON_COGNITO_USER_POOLS',
            apiKey: 'da2-pob7b7h6ifdazgvd33h3ap5zi4',
            graphqlPartnerEndpoint: 'https://hcelultztfe7dgovchscngrr34.appsync-api.us-west-2.amazonaws.com/graphql',
            partnerApiKey: 'da2-nmlnild4gjfirim3pk23d444im',
            graphqlNotificationsEndpoint: 'https://7edj4rga6nejvbxqd52tsdcm34.appsync-api.us-west-2.amazonaws.com/graphql',
            notificationsApiKey: 'da2-cpckmhl3tfhy7haaqzgybqqlji',
            identityPoolId: 'us-west-2:032e4758-554c-4093-9d83-cdc05ac06c4d',
            userPoolId: 'us-west-2_gs7ke0Hyc',
            userPoolWebClientId: '1hab3e1k5ovj8u479jv4mc4jsv',
            labelBucket: 'returnmates-label-prod',
            mediaBucket: 'returnmates-media-prod',
            apiGatewayGoldengateEndpoint: 'https://ofwavgksa9.execute-api.us-west-2.amazonaws.com/prod',
            apiGatewayGoldengateApiKey: 'ZaO6ZLWeCSVJOEqpRI6SlbwTKcBqNCNvC5jn4YbsZHf8XdD8IVqjMwKhJ99B9uKd1IBPvVo83wQvSGKJNM9I7Eae506jYREA3WHWtiShT9q0SmQfYsEKv64hTxbLgZjz',
        },
        google: {
            maps: 'AIzaSyCQc8pm0LbeAAiN_9kdOoh1k1sIFZRrXKg',
        },
        stripe: {
            publicKey: 'pk_live_51H0rulEfxrgq4pDv6tuMQrN3Mq2mtgSVsF1T1tyWctnD5BicXNGftOnDBoB0G8NHPdEQl2fmNIrvuPJ3mjx6QfRG00P8hCWSjp',
        },
        paymentCodes: (_c = {},
            _c[Plan.PER_PICKUP] = 'prod_IhjgF9w1mxtQFm',
            _c[Plan.MEMBERSHIP] = 'prod_HyZgEmZJIGMN1s',
            _c),
        subscriptionPriceId: 'price_1IaruVEfxrgq4pDvnsz8Lbed',
        oauth: {
            iosClientId: '106428630706-a8unm2f9vv2v6g1kmhfnkrjb3svcqd9p.apps.googleusercontent.com',
            androidClientId: '106428630706-jc4p1j48oclg7r8h2t87cp5fqjhna445.apps.googleusercontent.com',
        },
        returnmates: {
            shopify: 'https://api.returnmates.com/shopify',
            client: 'https://returnmates.com',
        },
    },
};
var envConfigs = __assign(__assign({}, defaultConfigs), { local: __assign(__assign({}, defaultConfigs.dev), { aws: __assign(__assign({}, defaultConfigs.dev.aws), { graphqlEndpoint: 'http://localhost:20002/graphql', apiKey: 'da2-fakeApiId123456', graphqlPartnerEndpoint: 'http://localhost:20006/graphql', partnerApiKey: 'da2-fakeApiId123456', graphqlNotificationsEndpoint: 'http://localhost:20004/graphql', notificationsApiKey: 'da2-fakeApiId123456' }), returnmates: {
            shopify: 'http://localhost:3000/local/shopify',
            client: 'https://dev.returnmates.com',
        } }) });
var defConfig = {
    jwtSecret: 'secret123',
};
export default (function (instance) {
    if (instance) {
        configInstance = instance;
    }
    var config = __assign(__assign({}, defConfig), envConfigs[configInstance]);
    return config;
});
//# sourceMappingURL=index.js.map